export const OPTHINES = {
  voteName: '2019poject/2019msndjb',
  buttonBg: '8c6646',
  mustSearch: 'Button',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  themeColor: {
    activeBgColor: '8c6646',
    inactiveBgColor: 'efeded',
  },
  tickets: {
    textFirst: '票数',
    textLast: '票',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/2019GoldenFoodAnnualList/FirstPage',
    },
    {
      tabName: '报名通道',
      tabPath: '/2019GoldenFoodAnnualList/Register',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019GoldenFoodAnnualList/Rules',
    },
  ],
  foodType: [
    {
      fullName: '2019食尚金榜之重庆最具人气火锅、串串',
      shortName: '重庆最具人气火锅、串串',
    },
    {
      fullName: '2019食尚金榜之重庆最火爆江湖菜馆',
      shortName: '最火爆江湖菜馆',
    },
    {
      fullName: '2019食尚金榜之重庆最火爆自助餐厅',
      shortName: '重庆必吃自助餐厅',
    },
    {
      fullName: '2019食尚金榜之重庆最情调餐厅',
      shortName: '重庆最情调餐厅',
    },
    {
      fullName: '2019食尚金榜之最特色品质餐厅',
      shortName: '最特色品质餐厅',
    },
    {
      fullName: '2019食尚金榜之重庆最潮美食地标',
      shortName: '重庆最潮美食地标',
    },
    {
      fullName: '2019年度榜样食品企业',
      shortName: '年度榜样食品企业',
    },
    {
      fullName: '2019食尚勋章人物',
      shortName: '食尚勋章人物',
    },
  ],
};
